import { pushEvent } from 'nike-ui/src/analytics/gtm';

export const trackPage = page => {
    pushEvent('trackPage', 'trackPage', 'trackPage', 'location', window.location.href);
    pushEvent('trackPage', 'trackPage', 'trackPage', 'page', page);
};

export const trackConversion = label => pushEvent('conversion', 'conversion', 'conversion', label, null);

export const measureTime = name =>
    window.performance && pushEvent('timing_complete', 'Load measurement', name, name, Math.round(performance.now()));
